<template>

<div class="container bootstrap snippet">
        <div class="container-fluid">
            <div class="portlet portlet-default" style="border: 0px">
                <div id="chat">
                    <div >
                    <div class="portlet-body chat-widget" style="overflow-y: auto; width: auto;">
                        <div class="row">
                            <div class="container-fluid">
                                <p class="text-center text-muted small"></p>
                            </div>
                        </div>
                        <h4>{{ dados }}</h4>
                        <div class="row " v-for="messages of messages" v-bind:key="messages['.key'] ">
                            <div class="container-fluid">
                                <div class="media">
                                    <a class="pull-left" >
                                        <img class="media-object img-chat img-circle" v-if= messages.perfil :src="messages.perfil" alt="">
                                    </a>
                                    <div class="media-body">
                                        <p class="media-heading col-md-4">{{ messages.usuario }}
                                            <span class="small pull-right col-md-4">{{ new Date( messages.val().date).toLocaleString().substr(0, 16) }}</span>
                                        </p>
                                        <h4>{{ (JSON.parse(messages.val().JSON)).text }}</h4>
                                        <a v-bind:href= "messages.imagem" target="_blank"><img v-if= messages.imagem :src= "messages.imagem" height="200" width="200" class="zoom" ></a>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent="Consultar(chaveacesso)" class="form-home">
                        <div class="card" style="border:0px">
                           <div class="card-body">
                            <div class="form-group">
                               <input autofocus v-model="chaveacesso" id="final" class="form-control w-50" placeholder="Nova chave de acesso"> <!-- placeholder="Chave de acesso"> -->
                            </div>
                            <button class="btn btn-primary w-20" :disabled="loading">
                              <template v-if="loading">
                                Processando...
                                <i class="fa fa-spinner fa-spin"></i>
                              </template>
                              <template v-else>
                                Seguir Danfe
                              <i class="fa fa-sign-in-alt"></i>
                              </template>
                            </button>
                            <p>
                            <p>
                            <a href="//play.google.com/store/apps/details?id=br.com.infonotas.app"><img src="/googleplay.ico" height="40" width="150"></a>
                            <p>
                              Baixe gratuitamente o App e interaja agora mesmo no processo logístico!
                            </p>
                          </div>
                        </div>
                      </form>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.col-md-4 -->

</div>

</template>

<script >
import { isNull } from 'util';
export default {
  name: 'Consulta',
  data: () => ({
    messages: [],
    dados: 'Aguarde Processando...'
  }),
  created () {
    this.$conectado = false
    this.getData()

  },
  methods: {
     async getData () {
      if (!this.$conectado) {
        var res = await this.$firebase.auth().signInWithEmailAndPassword('novo20@btllog.com.br', 'a12345678')
          .then(conectou => {

            this.$conectado = true
            var ref = this.$firebase.database().ref(`18_05/docs/`+this.$route.params.Chave+`/threads`)
            ref.on('value', data =>{
                 if (!data.exists()){this.dados = 'REGISTRO NAO ENCONTRADO'} else {this.dados = ''}
                data.forEach(grupo => {
                const ref2 = this.$firebase.database().ref(`18_05/threads/`+grupo.key+`/messages`)
                        ref2.on('value', data2 =>{
                                this.messages = []
                                data2.forEach(element => {
                                const ref3 = this.$firebase.database().ref(`18_05/users/`+(element.val())['user-firebase-id']+`/meta`)
                                ref3.on('value', data3 =>{
                                    element.email = data3.val().email
                                    element.perfil = data3.val().pictureURL
                                    element.usuario = data3.val().status
                                    element.imagem = (JSON.parse(element.val().JSON))['image-url']
                                    this.messages.push(element)
                                    location.assign("#final")
                                });
                                });
                        })
                });
            })
          })
          location.assign("#final")
          .then(momento2 => {
            location.assign("#final")
          })
      }
    },
      Consultar (chaveacesso) {
      let chaveId=chaveacesso
      try {
        this.$router.push({name: 'consulta',params:{Chave:chaveId}})
        location.reload();

      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zoom:hover {
    transform: scale(2);
    display:block;
}
.zoom {
 transition: transform 1s;
 display:block;
}

 .portlet {
    margin-bottom: 1px;
}

.btn-white {
    border-color: #cccccc;
    color: #333333;
    background-color: #ffffff;
}

.portlet {
    border: 1px solid;
}

.portlet .portlet-heading {
    padding: 0 15px;
}

.portlet .portlet-heading h4 {
    padding: 1px 0;
    font-size: 12px;
}

.portlet .portlet-heading a {
    color: #fff;
}

.portlet .portlet-heading a:hover,
.portlet .portlet-heading a:active,
.portlet .portlet-heading a:focus {
    outline: none;
}

.portlet .portlet-widgets .dropdown-menu a {
    color: #333;
}

.portlet .portlet-widgets ul.dropdown-menu {
    min-width: 0;
}

.portlet .portlet-heading .portlet-title {
    float: left;
}

.portlet .portlet-heading .portlet-title h4 {
    margin: 10px 0;
}

.portlet .portlet-heading .portlet-widgets {
    float: right;
    margin: 8px 0;
}

.portlet .portlet-heading .portlet-widgets .tabbed-portlets {
    display: inline;
}

.portlet .portlet-heading .portlet-widgets .divider {
    margin: 0 5px;
}

.portlet .portlet-body {
    padding: 15px;
    background: #fff;
}

.portlet .portlet-footer {
    padding: 10px 15px;
    background: #e0e7e8;
}

.portlet .portlet-footer ul {
    margin: 0;
}

.portlet-green,
.portlet-green>.portlet-heading {
    border-color: #16a085;
}

.portlet-green>.portlet-heading {
    color: #fff;
    background-color: #16a085;
}

.portlet-orange,
.portlet-orange>.portlet-heading {
    border-color: #f39c12;
}

.portlet-orange>.portlet-heading {
    color: #fff;
    background-color: #f39c12;
}

.portlet-blue,
.portlet-blue>.portlet-heading {
    border-color: #2980b9;
}

.portlet-blue>.portlet-heading {
    color: #fff;
    background-color: #2980b9;
}

.portlet-red,
.portlet-red>.portlet-heading {
    border-color: #e74c3c;
}

.portlet-red>.portlet-heading {
    color: #fff;
    background-color: #e74c3c;
}

.portlet-purple,
.portlet-purple>.portlet-heading {
    border-color: #8e44ad;
}

.portlet-purple>.portlet-heading {
    color: #fff;
    background-color: #8e44ad;
}

.portlet-default,
.portlet-dark-blue,
.portlet-default>.portlet-heading,
.portlet-dark-blue>.portlet-heading {
    border-color: #34495e;
}

.portlet-default>.portlet-heading,
.portlet-dark-blue>.portlet-heading {
    color: #fff;
    background-color: #34495e;
}

.portlet-basic,
.portlet-basic>.portlet-heading {
    border-color: #333;
}

.portlet-basic>.portlet-heading {
    border-bottom: 1px solid #333;
    color: #333;
    background-color: #fff;
}

@media(min-width:7680px) {
    .portlet {
        margin-bottom: 50px;
    }
}

.img-chat{
width:50px;
height:50px;
}

.text-green {
    color: #16a085;
}

.text-orange {
    color: #f39c12;
}

.text-red {
    color: #e74c3c;
}
</style>
